<template>
    <div class="cs-crossSell" v-if="isShown && shownCrossSell">
        <div class="cs-crossSell-title">{{dictionaryFile.specialOffer}}</div>
        <div class="cs-crossSell-subtitle">{{dictionaryFile.clickOfferToAddToCart}}</div>
          <div class="cs-crossSell-offer" v-for="(offer, index) of offersArray" :key="offer.serviceID" @click="onProductCrossSellClick(offer,index)">
            <span class="cs-crossSell-offer-title" :class="`cs-crossSell-offer-${index}`">{{offer.serviceQuantity}} {{offer.serviceLabel}}</span>
            <span class="cs-crossSell-offer-discounted-price" :class="`cs-crossSell-offer-${index}`">{{offer.serviceDiscountedPrice}}€</span>
            <span class="cs-crossSell-offer-subtitle">{{dictionaryFile.toYourLast}} {{getCrossMediaQuantity(index)}} {{dictionaryFile.posts}}</span>
            <span class="cs-crossSell-offer-original-price"> <span class="cs3-text-strike">{{offer.serviceOriginalPrice}} €</span> </span>
            <div class="cs-crossSell-offer-button">
              <img class="cs-crossSell-offer-icon" :src="dictionaryFile.plusIcon">
            </div>
          </div>
    </div>
</template>

<script>
import axios from "axios";
import {API_URL,TRIAL_GET_SPECIAL_OFFERS_ENDPOINT, ADDED_SPECIAL_OFFERS_ENDPOINT} from "../../assets/js/api";
import {increaseCartItemCounter} from '../../assets/js/csService';
import { TRIAL_TYPE } from '../../assets/config';
export default {
    name: 'CrossSell',
    emits: ['showSpecialOffers'],
    props: {
        dictionaryFile: {
            type: Object,
            required: true
        },
        isShown: {
            type: Boolean,
            required: true
        },
        userInfo: {
            type: Object,
            required: false,
        }
    },
    methods: {
        onProductCrossSellClick: async function(offer, index){
            axios.post(`${API_URL}${ADDED_SPECIAL_OFFERS_ENDPOINT}`, {
                    userID: this.userInfo.uid,
                    trialType: TRIAL_TYPE
                });
            var productRequestFormData = new URLSearchParams();
            productRequestFormData.append('action','woocommerce_ajax_add_to_cart');
            productRequestFormData.append('product_id', offer.serviceID);
            productRequestFormData.append('product_qty', 1);
            productRequestFormData.append('links', this.getLastXMediasLinks(this.getCrossMediaQuantity(index)));
            productRequestFormData.append('initialQuantities', this.getLastXMediasLikes(this.getCrossMediaQuantity(index)));

            // eslint-disable-next-line no-undef
            await axios.post(wc_add_to_cart_params.ajax_url, productRequestFormData,{
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });


            increaseCartItemCounter();
            this.redirectToCheckout();
        },
        redirectToCheckout: function(){
            // eslint-disable-next-line no-undef
            location.href = this.dictionaryFile.checkoutURL;
        },
        getCrossMediaQuantity(index){
            return this.userInfo.medias.length < this.offersArray[index].medias ? this.userInfo.medias.length : this.offersArray[index].medias;
        },
        getLastXMediasLinks(amount){
            var links = [];
            for(var i = 0; i < amount; i++){
                links.push('https://www.instagram.com/p/' + this.userInfo.medias[i].shortcode);
            }
            return links;
        },
        getLastXMediasLikes(amount){
            var links = [];
            for(var i = 0; i < amount; i++){
                links.push(this.userInfo.medias[i].likes);
            }
            return links;
        }
    },
    data: function(){
        return {
            offersArray: [],
            shownCrossSell: false
        }
    },
    mounted: async function() {
        await axios.get(`${API_URL}${TRIAL_GET_SPECIAL_OFFERS_ENDPOINT}`,
            {
                params: {
                    userID: this.userInfo.uid,
                    trialType: TRIAL_TYPE
                }
            },{headers: {"Content-Type": "application/json"}}
        ).then( axRes => {
            this.shownCrossSell = axRes.data.showSpecialOffers ? axRes.data.showSpecialOffers : false;
            this.$emit("showSpecialOffers", this.shownCrossSell);
            this.offersArray = axRes.data.showSpecialOffers ? axRes.data.specialOffers.sort((offerEl1, offerEl2) => Number.parseInt(offerEl1.serviceQuantity) - Number.parseInt(offerEl2.serviceQuantity)) : [];
        });
    }
}
</script>

<style scoped>
.cs-crossSell {
    background: linear-gradient(105.17deg, #F7AD62 4.1%, #F385D9 98.58%);
    padding: 10px;
    border-radius: 0 0 25px 25px;
}

.cs-crossSell-title {
    color: white;
    font-weight: 600;
    font-size: 20px;
}
 
.cs-crossSell-subtitle {
    color: white;
    font-weight: 600;
    font-size: 13px;
}

.cs-crossSell-offer {
    background: white;
    border-radius: 25px;
    display: grid;
    grid-template-columns: 2.5fr 1.1fr auto;
    grid-template-rows: 0.9fr 1fr;
    margin: 10px 0;
    height: 65px;
    cursor: pointer;
}

.cs-crossSell-offer-icon {
    width: 30px;
    height: 30px;
}

.cs-crossSell-offer-title {
    font-weight: 700;
    font-size: 20px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    grid-column: 1;
    grid-row: 1;
    margin-bottom: -10px
}

.cs-crossSell-offer-0{
    color: #B6876D;
}

.cs-crossSell-offer-1{
    color: #9C9C9C;
}
  
.cs-crossSell-offer-2{
    color: #C69401;
}
  
  
.cs-crossSell-offer-subtitle {
    font-weight: 400;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    grid-column: 1;
    grid-row: 2;
}
  
.cs-crossSell-offer-discounted-price {
    font-weight: 700;
    font-size: 22px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    grid-column: 2;
    grid-row: 1;
    margin-bottom: -10px
}
  
.cs-crossSell-offer-original-price {
    font-weight: 700;
    font-size: 16px;
    color: #F15B65;
    display: flex;
    align-items: center;
    justify-content: center;
    grid-column: 2;
    grid-row: 2;
}
  
.cs3-text-strike {
    background: linear-gradient(165deg, transparent 47.75%, currentColor 50.5%, currentColor 52.5%, transparent 52.25%);
    height: 25px;
}
  
.cs-crossSell-offer-button {
    background: linear-gradient(180deg, #9D8DF8 0%, #5538FB 100%);
    grid-column: 3;
    grid-row: 1 /span 2;
    min-width: 70px;
    height: 100%;
    border-radius: 0 25px 25px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
}
  
</style>
